




























































































































































































































































































































































































































































import {
  Vue, Component, Mixins, Prop,
} from 'vue-property-decorator';
import MyList from '@/mixins/list';
import _ from 'lodash';

@Component
export default class extends Mixins(MyList) {
  @Prop() applyId!: number;

  applyInfo: any = {};

  processItems: any[] = [];

  bookingInfo: any = {};

  tags: any[] = [];

  chooseTags: any[] = [];

  mediasImg: [] = [];

  thumbnails = '';

  priceSettings: any[] = [];

  async mounted() {
    this.spinLoading = true;

    const res1 = await this.$store.dispatch('stadium/getTags', {});
    if (res1 && res1.Data) {
      this.tags = res1.Data;
    }

    // 获取入驻信息
    const res = await this.$store.dispatch('stadium/applyInfo1', {
      apply_id: this.applyId,
    });

    if (res && res.Data) {
      this.applyInfo = res.Data;

      if (this.applyInfo.bank) {
        this.applyInfo.bank_card_no = this.applyInfo.bank.card_no;
        this.applyInfo.bank_card_username = this.applyInfo.bank.card_name;
        this.applyInfo.bank_name = this.applyInfo.bank.bank_name;
        this.applyInfo.bank_phone = this.applyInfo.bank.phone;
      }

      if (this.applyInfo.tags) {
        this.applyInfo.tags = JSON.parse(this.applyInfo.tags);
      }

      for (const obj of this.tags) {
        if (_.indexOf(this.applyInfo.tags, obj.id) !== -1) {
          this.chooseTags.push({
            id: obj.id,
            name: obj.name,
          });
        }
      }

      // 价格设置
      const res3 = await this.$store.dispatch(
        'stadium/getStadiumPriceSetting',
        {
          stadium_id: this.applyInfo.new_stadium_id,
        },
      );

      if (res3 && res3.Data) {
        for (const obj of res3.Data) {
          obj.status = 1;
          obj.price /= 100;
          // if (obj.week_from === 0) {
          //   obj.week_from = 7;
          // }
          // if (obj.week_to === 0) {
          //   obj.week_to = 7;
          // }
        }
        this.priceSettings = res3.Data.sort(
          (a: any, b: any) => b.price - a.price,
        );
      }

      const res2 = await this.$store.dispatch('stadium/bookingInfo', {
        stadium_id: this.applyInfo.new_stadium_id,
      });
      if (res2 && res2.Data) {
        this.bookingInfo = res2.Data;

        if (res2.Data.stadium_detail) {
          this.applyInfo.ground_count = res2.Data.stadium_detail.ground_count;
          this.applyInfo.lately_turnover = res2.Data.stadium_detail.lately_turnover;
          this.applyInfo.earning_top_month = res2.Data.stadium_detail.earning_top_month;
          this.applyInfo.earning_under_month = res2.Data.stadium_detail.earning_under_month;
          this.applyInfo.other_earning_ways = res2.Data.stadium_detail.other_earning_ways;
          this.applyInfo.rent_cost = res2.Data.stadium_detail.rent_cost;
          this.applyInfo.members_payment = res2.Data.stadium_detail.members_payment;
          this.applyInfo.utilities = res2.Data.stadium_detail.utilities;
          this.applyInfo.members_count = res2.Data.stadium_detail.members_count;
          this.applyInfo.complaint_mobile = res2.Data.stadium_detail.complaint_mobile;
        }

        if (res2.Data.stadium.media) {
          const imgs = res2.Data.stadium.media.split(',');
          this.mediasImg = imgs;
        }

        if (res2.Data.stadium.thumbnails) {
          this.thumbnails = res2.Data.stadium.thumbnails;
        }

        // console.log(this.priceSettings)
      }

      // 获取上线设置进度
      const res0 = await this.$store.dispatch('stadium/onlineProgress', {
        stadium_id: this.applyInfo.new_stadium_id,
      });
      if (res0 && res0.Data) {
        this.processItems = res0.Data;
      }
    }

    // 获取片场信息

    this.spinLoading = false;
  }

  getStatus(id: string) {
    const obj = _.find(
      this.processItems,
      (o: any) => Number(o.id) === Number(id),
    );
    // if (id == '101') {
    //   // 包场
    //   if (this.applyInfo.blocks && this.applyInfo.blocks.length > 0) {
    //     return '(已完成设置)'
    //   } else {
    //     return '(未设置)'
    //   }
    // }
    if (id === '9') {
      if (obj) {
        if (Number(obj.status) === 1) {
          // 已放弃
          return '1';
        }

        // 还没放弃
        return '';
      }
      return '';
    }
    if (obj) {
      return Number(obj.status) === 1
        ? '(已完成设置)'
        : Number(obj.status) === 2
          ? '(跳过)'
          : '(未设置)';
    }
    return '';
  }

  getPrice(week: number, hour: number, groundId: number) {
    const data = this.priceSettings;

    for (const obj of data) {
      if (
        week >= obj.week_from
        && week <= obj.week_to
        && hour >= obj.hour_from
        && hour < obj.hour_to
        && groundId >= obj.ground_id_from
        && groundId <= obj.ground_id_to
      ) {
        // 满足条件
        return `<div style="background-color:${obj.color.replace('"', '')}">${
          obj.price
        }</div>`;
      }
      continue;
    }
  }

  getPrice1(week: number, hour: number, groundId: number) {
    const price = this.getPrice(week, hour, groundId);
    // console.log(week, hour, groundId)
    if (price) {
      return price;
    }
    return '未设置';
  }

  async allowNotUpgrade() {
    this.$confirm({
      title: '确认信息',
      content: '您确定允许用户放弃升级智能场馆吗？',
      onOk: async () => {
        const res = await this.$store.dispatch('stadium/allowNotUpgrade', {
          stadium_id: this.applyInfo.new_stadium_id,
        });
        if (res && res.Message && res.Message === 'success') {
          this.$message.success('操作成功');
          // this.loadData1()
        } else {
          this.$message.error('操作失败');
        }
      },
    });
  }
}
